<script lang="ts" setup>
import ogImage from '@images/og-image.png'

const { $api } = useNuxtApp()
const config = useRuntimeConfig()
const { locale } = useI18n()

// Helper untuk mempermudah akses locale sebagai key
const lang = computed(() => locale.value as 'en' | 'id')

const url = computed(() => {
    return `${config.public.jobSeekerUrl}/privacy-policy`
})

const privacyData = ref<any>(null)

// Inisialisasi data
const { data } = await $api.landingPage.getPrivacyPolicy()

privacyData.value = data

// Gunakan computed untuk title dan content agar otomatis update saat locale berubah
const privacyPolicyTitle = computed(() => {
    const titles = data.value?.data?.title || { en: 'Privacy & Policy', id: 'Kebijakan Privasi' }
    return titles[lang.value] || titles.en
})

const privacyPolicyContent = computed(() => {
    // Pastikan path ini sesuai dengan struktur API Anda (data.content atau data.content.description)
    return data.value?.data?.content?.description[lang.value] || ''
})

/** Head configurations - Dibuat reaktif menggunakan computed properties */
useSeoMeta({
    title: () => privacyPolicyTitle.value,
    description: () => lang.value === 'id'
        ? 'Baca Kebijakan Privasi kami untuk memahami bagaimana kami mengumpulkan dan melindungi informasi Anda.'
        : 'Read our Privacy & Policy to understand how we collect, use, and protect your personal information.',
    ogType: 'website',
    ogUrl: () => url.value,
    ogTitle: () => privacyPolicyTitle.value,
    ogImage: () => ogImage,
    twitterCard: 'summary_large_image',
})

useHead({
    link: [
        {
            rel: 'canonical',
            href: url.value,
    }
    ]
})
</script>

<template>
  <VContainer>
    <h1 class="text-h4 mb-6">
      {{ privacyPolicyTitle }}
    </h1>
    <VCard
      v-if="privacyPolicyContent"
      flat
      border
    >
      <VCardText class="pa-6">
        <div
          class="privacy-policy-content"
          v-html="privacyPolicyContent"
        />
      </VCardText>
    </VCard>
    <div
      v-else
      class="text-center pa-10"
    >
      <VProgressCircular
        indeterminate
        color="primary"
      />
    </div>
  </VContainer>
</template>

<style lang="scss" scoped>
:deep(.privacy-policy) {
    ul,
    ol {
        padding-left: 20px;
    }
}
</style>
